import { render } from "./CardContent.vue?vue&type=template&id=ec883648"
import script from "./CardContent.vue?vue&type=script&lang=js"
export * from "./CardContent.vue?vue&type=script&lang=js"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__